import { __assign, __decorate, __extends } from "tslib";
import * as React from 'react';
import { Terminator, terminatorSuggestionToTerminatorProps, } from './terminator';
import { withExperiments } from '../../../component-decorators/with-experiments';
import { getTerminatorSuggestion, } from './terminator-data';
import { withMarketplaceStore, } from '../../../component-decorators/with-marketplace-store';
var TerminatorContainer = /** @class */ (function (_super) {
    __extends(TerminatorContainer, _super);
    function TerminatorContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerminatorContainer.prototype.render = function () {
        var _a = this.props, term = _a.term, experiments = _a.experiments, marketplaceStore = _a.marketplaceStore;
        var suggestion = term
            ? getTerminatorSuggestion(term, experiments)
            : null;
        return suggestion ? (React.createElement(Terminator, __assign({}, terminatorSuggestionToTerminatorProps(this.props.term, suggestion, marketplaceStore)))) : null;
    };
    TerminatorContainer = __decorate([
        withExperiments,
        withMarketplaceStore
    ], TerminatorContainer);
    return TerminatorContainer;
}(React.Component));
export { TerminatorContainer };
//# sourceMappingURL=terminator-container.js.map